import translation from 'translation';

export function getContentsSorts(sortType) {
  const { t } = translation;

  const byTime = {
    sort_type: sortType || 'desc',
    sort: 'time',
    value: 'time',
    label: sortType ? t('content:publishDate') : t('filter:newest'),
  };

  const byScore = {
    sort_type: sortType || 'desc',
    sort: 'score',
    value: 'score',
    label: sortType ? t('content:relatedContents') : t('filter:mostRelated'),
  };

  const byRepublish = {
    sort_type: sortType || 'desc',
    sort: 'copy_count',
    value: 'copy_count',
    label: sortType ? t('content:republishCount') : t('filter:mostRepublished'),
  };

  const byLike = {
    sort_type: sortType || 'desc',
    sort: 'like_count',
    value: 'like_count',
    label: sortType ? t('content:likeCount') : t('filter:mostLike'),
  };

  const byFollowers = {
    sort_type: sortType || 'desc',
    sort: 'follower_count',
    value: 'follower_count',
    label: sortType ? t('filter:followerCount') : t('filter:mostFollower'),
  };

  const byComment = {
    sort_type: sortType || 'desc',
    sort: 'comment_count',
    value: 'comment_count',
    label: sortType ? t('content:commentCount') : t('filter:mostComment'),
  };

  const byViewInstagram = {
    sort_type: sortType || 'desc',
    sort: 'view_count',
    value: 'view_count',
    label: sortType ? t('content:videoViewCount') : t('filter:mostViewVideo'),
    media_type: ['video'],
  };

  const byViewTelegram = {
    sort_type: sortType || 'desc',
    sort: 'view_count',
    value: 'view_count',
    label: sortType ? t('content:viewCount') : t('filter:mostView'),
    media_type: ['video'],
  };

  const byPageNumber = {
    sort_type: sortType || 'desc',
    sort: 'page_number',
    value: 'page_number',
    label: sortType
      ? t('content:pageNumber')
      : t('filter:descendingPageNumber'),
  };

  const byPageNumberAsc = {
    sort_type: 'asc',
    value: 'page_number',
    label: t('filter:ascendingPageNumber'),
  };

  const byShare = {
    sort_type: sortType || 'desc',
    sort: 'share_count',
    value: 'share_count',
    label: sortType ? t('content:republishCount') : t('filter:mostRepublished'),
  };

  const byView = {
    sort_type: sortType || 'desc',
    sort: 'view_count',
    value: 'view_count',
    label: t('content:countView'),
  };

  const byReply = {
    sort_type: sortType || 'desc',
    sort: 'reply_count',
    value: 'reply_count',
    label: sortType ? t('content:replyCount') : t('filter:mostReply'),
  };

  const byViewerComment = {
    sort_type: sortType || 'desc',
    sort: 'reply_count',
    value: 'reply_count',
    label: sortType ? t('content:commentSortLabel') : t('filter:mostReply'),
  };

  const byReaction = {
    sort_type: sortType || 'desc',
    sort: 'reactions_count',
    value: 'reactions_count',
    label: sortType ? t('content:reactionCount') : t('filter:mostReaction'),
  };

  const sorts = {
    multiPlatform: sortType ? [byTime] : [],
    nativePlatforms: sortType ? [byTime] : [],
    news: [byTime, byRepublish, byScore, byView],
    instagram: [byTime, byLike, byComment, byViewInstagram, byScore],
    instagramComment: [byTime, byScore],
    instagramCommentByPost: [byTime, byScore],
    instagramStories: [byTime],
    twitter: [
      byTime,
      byRepublish,
      byLike,
      byFollowers,
      byScore,
      byView,
      byReply,
    ],
    virasty: [
      byTime,
      byRepublish,
      byView,
      byViewerComment,
      byReaction,
      byScore,
    ],
    telegram: [byTime, byViewTelegram, byComment, byScore],
    newspaper: sortType
      ? [byTime, byPageNumber]
      : [byTime, byPageNumber, byPageNumberAsc],
    linkedin: [byTime, byShare, byLike, byComment],
  };

  return sorts;
}
